// extracted by mini-css-extract-plugin
export default {"gliderItemTV":"Slider_gliderItemTV__s93kE"};